export enum PieChartColor {
  black = 'black',
  blue = 'blue',
  green = 'green',
  red = 'red',
  teal = 'teal',
  none = 'none',
}

export interface IPieChartData {
  border?: PieChartColor | undefined;
  spacing: boolean;
  rotation?: number;
  slices: IPieChartSlice[];
}

export interface IPieChartSlice {
  color?: PieChartColor;
  percent: number;
}

export interface IPieChartSegment {
  shape: string;
  color?: PieChartColor;
}
